import React from 'react'
import styles from '../styles/Footer.module.css'
import footerLogo from '../../../../assets/main-logo.png'
import { FaFacebook } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FaInstagram } from "react-icons/fa6";
import { Link } from 'react-router-dom/cjs/react-router-dom';

const Footer = () => {
    return (
        <div>
            <div className={styles.footer}>
                <div className={`container-fluid ${styles.footer_wrapper}`}>
                    <div className="container">
                        <div className="row" id="footer-section">
                            <div className="col-xl-5 col-lg-3 col-md-12 col-sm-12">
                                <Link>
                                    <div className={styles.footer_logo}>
                                        <img src={footerLogo} alt="" />
                                    </div>
                                </Link>
                                <div className={styles.footer_about}>
                                    <p>Empowering learners through accessible and engaging online education.
                                        Elmaam is a leading online learning platform dedicated to providing high-quality, flexible, and affordable educational experiences. </p>
                                </div>
                            </div>

                            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 ms-auto">
                                <div className={styles.categories}>
                                    <div className={styles.help_link_wrapper}>
                                        <div className={styles.links_header}>
                                            <h4>Contact Us</h4>
                                        </div>
                                        <ul className={styles.footer_social}>
                                            <li><Link> Taminat Complex, Building No 55/9, 5th floor, Bausher, Muscat, Sultanate of Oman</Link></li>
                                            <li><Link>Tel: +968 22849050</Link></li>
                                            <li><Link>Mail: info@alshawamikh.com</Link></li>
                                        </ul>
                                    </div>
                                    <div className={styles.social_links}>
                                        <Link>
                                            <div className={styles.social_icon_container}>
                                                <span><FaFacebook /></span>
                                            </div>
                                        </Link>

                                        <Link>
                                            <div className={styles.social_icon_container}>
                                                <span><FaXTwitter /></span>
                                            </div>
                                        </Link>

                                        <Link>
                                            <div className={styles.social_icon_container}>
                                                <span><FaInstagram /></span>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer